import CtaTextOnlyBox from './ctaTextOnlyBox';

export default CtaTextOnlyBox;
